export const getSecondaryPlacement = (placement) => {
    switch (placement) {
        case 'bottom-start':
        case 'top-start':
            return 'left';
        case 'bottom-end':
        case 'top-end':
            return 'right';
        case 'right-start':
        case 'left-start':
            return 'top';
        case 'right-end':
        case 'left-end':
            return 'bottom';
        case 'left':
        case 'right':
        case 'top':
        case 'bottom':
            return 'center';
        case undefined:
        case 'auto':
        case 'auto-start':
        case 'auto-end':
            return undefined;
    }
};
//# sourceMappingURL=get_secondary_placement.js.map